import React from 'react';
import { DndProvider } from 'react-dnd';
import { Controller, useFormContext } from 'react-hook-form';
import { HTML5Backend } from 'react-dnd-html5-backend';

import FolderTree from './FolderTree';

export default function FolderStructure({ index }) {
  const { control } = useFormContext();
  return (
    <DndProvider backend={HTML5Backend}>
      <Controller
        name={`actions[${index}].folderStructure`}
        control={control}
        rules={{ required: 'Required' }}
        render={({ field }) => <FolderTree value={field.value} onChange={field.onChange} />}
      />
    </DndProvider>
  );
}
